export default __webpack_public_path__ + "static/media/madbar.370bd89f.jpg";